import { css } from 'lit';

export default css`
  :host {
    display: block;
    width: 100%;
    --private-achievement-container-padding: 16px 24px 16px 24px;
  }

  .achievement-container {
    display: flex;
    box-sizing: border-box;
    width: 100%;
    flex-direction: column;
    gap: 10px;
    padding: var(--private-achievement-container-padding);
  }

  .achievement-header-container {
    display: flex;
    justify-content: space-between;
  }

  amityeko-tg-body-two {
    color: #0f86fe;
    cursor: pointer;
  }
`;
